import React from "react";

import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography
} from "@material-ui/core";

import api
  from "../../services/api";


// KORAX SIGN V0.7B TIMELINE UI

const EVENT_INFO = {

  DOCUMENT_CREATED: {
    label:
      "Documento criado",
    kind:
      "neutral"
  },

  SIGNATURE_FIELD_SET: {
    label:
      "Campo de assinatura configurado",
    kind:
      "neutral"
  },

  SIGNING_LINK_CREATED: {
    label:
      "Link seguro gerado",
    kind:
      "info"
  },

  DOCUMENT_SENT: {
    label:
      "Documento enviado por e-mail",
    kind:
      "info"
  },

  EMAIL_DELIVERY_FAILED: {
    label:
      "Falha no envio por e-mail",
    kind:
      "error"
  },

  SIGNING_EMAIL_RESENT: {
    label:
      "Documento reenviado por e-mail",
    kind:
      "info"
  },

  SIGNING_EMAIL_RESEND_FAILED: {
    label:
      "Falha no reenvio por e-mail",
    kind:
      "error"
  },

  SIGNING_WHATSAPP_SENT: {
    label:
      "Documento enviado pelo WhatsApp",
    kind:
      "info"
  },

  SIGNING_WHATSAPP_FAILED: {
    label:
      "Falha no envio pelo WhatsApp",
    kind:
      "error"
  },

  SIGNING_RESEND_COMMIT_FAILED: {
    label:
      "Novo link não foi ativado",
    kind:
      "error"
  },

  LINK_OPENED: {
    label:
      "Link aberto pelo signatário",
    kind:
      "info"
  },

  EMAIL_OTP_SENT: {
    label:
      "Código de confirmação enviado",
    kind:
      "neutral"
  },

  EMAIL_VERIFIED: {
    label:
      "E-mail confirmado",
    kind:
      "success"
  },

  DOCUMENT_VIEWED: {
    label:
      "Documento visualizado",
    kind:
      "info"
  },

  TERMS_ACCEPTED: {
    label:
      "Termos aceitos",
    kind:
      "success"
  },

  SIGNATURE_DRAWN: {
    label:
      "Assinatura desenhada",
    kind:
      "success"
  },

  SIGNATURE_TYPED: {
    label:
      "Assinatura digitada",
    kind:
      "success"
  },

  DOCUMENT_SIGNED: {
    label:
      "Documento assinado",
    kind:
      "success"
  },

  FINAL_PDF_GENERATED: {
    label:
      "Documento final gerado",
    kind:
      "success"
  },

  DOCUMENT_COMPLETED: {
    label:
      "Processo concluído",
    kind:
      "success"
  }
};


const COLOR_BY_KIND = {
  neutral:
    "#98A2B3",

  info:
    "#2E90FA",

  success:
    "#12B76A",

  error:
    "#F04438"
};


const formatDate =
  value => {

    if (!value) {
      return "-";
    }


    const date =
      new Date(
        value
      );


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {

      return "-";
    }


    return date
      .toLocaleString(
        "pt-BR"
      );
  };


const channelLabel =
  channel => {

    const value =
      String(
        channel ||
        ""
      )
        .toLowerCase();


    if (
      value ===
      "whatsapp"
    ) {

      return "WhatsApp";
    }


    if (
      value ===
      "email"
    ) {

      return "e-mail";
    }


    return "";
  };


const reasonLabel =
  reason => {

    const value =
      String(
        reason ||
        ""
      );


    if (
      value ===
      "WHATSAPP_NOT_CONNECTED"
    ) {

      return "WhatsApp da empresa desconectado.";
    }


    if (
      value ===
      "SMTP_NOT_CONFIGURED"
    ) {

      return "E-mail da empresa não configurado.";
    }


    if (
      value ===
      "EMAIL_SEND_FAILED"
    ) {

      return "Falha no provedor de e-mail.";
    }


    if (value) {

      return "Não foi possível concluir o envio.";
    }


    return "";
  };


const descriptionFor =
  event => {

    const details =
      event
        ?.details ||
      {};


    const channel =
      channelLabel(
        details.channel
      );


    switch (
      event.type
    ) {

      case "SIGNING_LINK_CREATED":

        return details.resend
          ? `Novo link ativado após reenvio${channel ? ` por ${channel}` : ""}.`
          : `Link de assinatura preparado${channel ? ` para ${channel}` : ""}.`;


      case "DOCUMENT_SENT":

        return "A solicitação de assinatura foi enviada ao signatário.";


      case "SIGNING_EMAIL_RESENT":

        return "Um novo link de assinatura foi entregue por e-mail.";


      case "SIGNING_WHATSAPP_SENT":

        return "Um novo link de assinatura foi entregue pelo WhatsApp.";


      case "EMAIL_VERIFIED":

        return "O signatário confirmou o controle do e-mail através do código enviado.";


      case "DOCUMENT_VIEWED":

        return "O conteúdo do documento foi visualizado após a confirmação do e-mail.";


      case "TERMS_ACCEPTED":

        return "O signatário aceitou os termos apresentados para a assinatura.";


      case "DOCUMENT_SIGNED":

        return "A assinatura eletrônica foi registrada.";


      case "FINAL_PDF_GENERATED":

        return "O PDF final assinado e as evidências foram gerados.";


      case "DOCUMENT_COMPLETED":

        return "Todas as etapas deste processo foram concluídas.";


      case "SIGNING_EMAIL_RESEND_FAILED":
      case "SIGNING_WHATSAPP_FAILED":
      case "EMAIL_DELIVERY_FAILED":

        return (
          reasonLabel(
            details.reason
          ) ||
          (
            details
              .previousLinkPreserved
              ? "A entrega falhou e o link anterior permaneceu válido."
              : "A entrega não foi concluída."
          )
        );


      case "SIGNING_RESEND_COMMIT_FAILED":

        return "A mensagem chegou a ser enviada, mas o novo link não foi ativado. O link anterior permaneceu válido.";


      default:

        return "";
    }
  };


const fallbackLabel =
  type =>
    String(
      type ||
      "Evento"
    )
      .toLowerCase()
      .split("_")
      .map(
        item =>
          item
            ? item[0]
                .toUpperCase() +
              item
                .slice(1)
            : ""
      )
      .join(" ");


const KoraxSignTimeline = ({
  documentId
}) => {

  const [
    loading,
    setLoading
  ] =
    React.useState(true);


  const [
    refreshing,
    setRefreshing
  ] =
    React.useState(false);


  const [
    error,
    setError
  ] =
    React.useState("");


  const [
    events,
    setEvents
  ] =
    React.useState([]);


  const load =
    React.useCallback(
      async (
        silent = false
      ) => {

        if (
          !documentId
        ) {

          return;
        }


        if (silent) {

          setRefreshing(
            true
          );

        } else {

          setLoading(
            true
          );
        }


        setError(
          ""
        );


        try {

          const response =
            await api.get(
              `/korax-sign/documents/${documentId}/timeline`
            );


          setEvents(
            Array.isArray(
              response
                ?.data
                ?.events
            )
              ? response
                  .data
                  .events
              : []
          );

        } catch (err) {

          setError(
            err?.response
              ?.data
              ?.message ||
            "Não foi possível carregar o histórico."
          );

        } finally {

          setLoading(
            false
          );

          setRefreshing(
            false
          );
        }
      },
      [
        documentId
      ]
    );


  React.useEffect(
    () => {

      load();


      const interval =
        window
          .setInterval(
            () => {
              load(
                true
              );
            },
            30000
          );


      return () => {

        window
          .clearInterval(
            interval
          );
      };
    },
    [
      load
    ]
  );


  if (
    !documentId
  ) {

    return null;
  }


  return (

    <Paper
      elevation={0}
      style={{
        margin:
          "18px 24px 32px",
        padding:
          22,
        border:
          "1px solid #EAECF0",
        borderRadius:
          14,
        background:
          "#FFFFFF",
        boxSizing:
          "border-box"
      }}
    >

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{
          gap:
            12,
          marginBottom:
            22
        }}
      >

        <Box>

          <Typography
            style={{
              fontSize:
                17,
              fontWeight:
                900,
              color:
                "#101828"
            }}
          >
            Histórico da assinatura
          </Typography>


          <Typography
            style={{
              marginTop:
                4,
              fontSize:
                12,
              lineHeight:
                1.5,
              color:
                "#667085"
            }}
          >
            Acompanhe as etapas registradas neste documento.
          </Typography>

        </Box>


        <Button
          size="small"
          onClick={
            () =>
              load(
                true
              )
          }
          disabled={
            refreshing
          }
          style={{
            textTransform:
              "none",
            fontWeight:
              800,
            whiteSpace:
              "nowrap"
          }}
        >
          {
            refreshing
              ? "Atualizando..."
              : "Atualizar"
          }
        </Button>

      </Box>


      {loading
        ? (

          <Box
            display="flex"
            justifyContent="center"
            style={{
              padding:
                28
            }}
          >

            <CircularProgress
              size={25}
            />

          </Box>

        )
        : error
          ? (

            <Typography
              style={{
                color:
                  "#B42318",
                fontSize:
                  12.5
              }}
            >
              {error}
            </Typography>

          )
          : events.length === 0
            ? (

              <Typography
                style={{
                  color:
                    "#667085",
                  fontSize:
                    12.5
                }}
              >
                Nenhum evento registrado ainda.
              </Typography>

            )
            : (

              <Box>

                {events.map(
                  (
                    event,
                    index
                  ) => {

                    const info =
                      EVENT_INFO[
                        event.type
                      ] ||
                      {
                        label:
                          fallbackLabel(
                            event.type
                          ),
                        kind:
                          "neutral"
                      };


                    const color =
                      COLOR_BY_KIND[
                        info.kind
                      ] ||
                      COLOR_BY_KIND
                        .neutral;


                    const description =
                      descriptionFor(
                        event
                      );


                    return (

                      <Box
                        key={
                          event.id
                        }
                        display="flex"
                        alignItems="stretch"
                        style={{
                          minHeight:
                            62
                        }}
                      >

                        <Box
                          style={{
                            width:
                              30,
                            minWidth:
                              30,
                            position:
                              "relative"
                          }}
                        >

                          <Box
                            style={{
                              position:
                                "absolute",
                              top:
                                3,
                              left:
                                2,
                              width:
                                14,
                              height:
                                14,
                              borderRadius:
                                "50%",
                              background:
                                color,
                              boxShadow:
                                "0 0 0 4px #FFFFFF",
                              zIndex:
                                2
                            }}
                          />


                          {index <
                            events.length -
                              1 && (

                            <Box
                              style={{
                                position:
                                  "absolute",
                                top:
                                  17,
                                bottom:
                                  -3,
                                left:
                                  8,
                                width:
                                  2,
                                background:
                                  "#EAECF0"
                              }}
                            />

                          )}

                        </Box>


                        <Box
                          style={{
                            flex:
                              1,
                            paddingBottom:
                              18,
                            minWidth:
                              0
                          }}
                        >

                          <Box
                            display="flex"
                            alignItems="baseline"
                            justifyContent="space-between"
                            style={{
                              gap:
                                14,
                              flexWrap:
                                "wrap"
                            }}
                          >

                            <Typography
                              style={{
                                color:
                                  "#101828",
                                fontSize:
                                  13,
                                fontWeight:
                                  850
                              }}
                            >
                              {info.label}
                            </Typography>


                            <Typography
                              style={{
                                color:
                                  "#98A2B3",
                                fontSize:
                                  11.5
                              }}
                            >
                              {
                                formatDate(
                                  event
                                    .createdAt
                                )
                              }
                            </Typography>

                          </Box>


                          {description && (

                            <Typography
                              style={{
                                marginTop:
                                  4,
                                color:
                                  "#667085",
                                fontSize:
                                  12,
                                lineHeight:
                                  1.5
                              }}
                            >
                              {description}
                            </Typography>

                          )}

                        </Box>

                      </Box>
                    );
                  }
                )}

              </Box>
            )}

    </Paper>
  );
};


export default
  KoraxSignTimeline;
